import { type Asset } from 'contentful';
import { IMediaSource, type IMedia } from 'generated/contentful';
import { removeUndefinedTopLevelKeys } from 'lib/util';
import { Media, MediaAsset, MediaSource } from 'models/contentful/media/types';

export const CONTENTFUL_URI = '//images.ctfassets.net/3a3g2h3dvhht/';
export const IMGIX_URI = '//perfectmoment-content.imgix.net/';

export const toMediaSourceAsset = (fields: Asset['fields']): MediaAsset => ({
  url: fields.file?.url?.replace(CONTENTFUL_URI, IMGIX_URI),
  description: fields.description ?? null,
  title: fields.title ?? null,
  width: fields.file?.details?.image?.width ?? null,
  height: fields.file?.details?.image?.height ?? null,
});

const createMediaSource = (mediaSource?: IMediaSource): MediaSource | null => {
  if (mediaSource === undefined) {
    return null;
  }

  const {
    fields: { image, lowResolutionVideo, highResolutionVideo },
  } = mediaSource;

  const source: MediaSource = {
    image: toMediaSourceAsset(image.fields),
    lowResolutionVideo: lowResolutionVideo?.fields.file.url
      ? toMediaSourceAsset(lowResolutionVideo?.fields)
      : null,
    highResolutionVideo: highResolutionVideo?.fields.file.url
      ? toMediaSourceAsset(highResolutionVideo.fields)
      : null,
  };

  return source;
};

export default function toMedia(content: IMedia): Media {
  return removeUndefinedTopLevelKeys({
    xs: createMediaSource(content.fields.xs),
    s: createMediaSource(content.fields.s),
    m: createMediaSource(content.fields.m),
    l: createMediaSource(content.fields.l),
    xl: createMediaSource(content.fields.xl),
    xxl: createMediaSource(content.fields.xxl),
    showVideoControls: Boolean(content.fields.showVideoControls),
  }) as Media;
}
